<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-product-os-compat">
    <div
      :class="['sky-product-os-compat__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <i class="el-icon-arrow-right" />
      <el-select
        placeholder="请选择产品版本"
        v-model="item.productVersion"
        popper-class="sky-product-os-compat__autocomplete"
        class="sky-product-os-compat__select"
        filterable
      >
        <el-option v-for="(item, index) in productList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <i class="el-icon-arrow-right" />
      <el-select
        placeholder="请选择操作系统"
        v-model="item.os"
        popper-class="sky-product-os-compat__autocomplete"
        class="sky-product-os-compat__select"
        filterable
      >
        <el-option v-for="(item, index) in osList" :key="index" :label="$t(item.label)" :value="item.id"> </el-option>
      </el-select>
      <i class="el-icon-arrow-right" />
      <el-select
        placeholder="请选择兼容性"
        v-model="item.compatibleStatus"
        popper-class="sky-product-os-compat__autocomplete"
        class="sky-product-os-compat__select"
        filterable
      >
        <el-option v-for="(item, index) in compatibleList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <el-input
        :ref="item.limitDesc"
        popper-class="sky-moudle-branch__autocomplete"
        class="sky-product-os-compat__select"
        v-model="item.limitDesc"
        :placeholder="$t('若有条件兼容，请填写')"
      >
      </el-input>
      <i class="sk-icon-remove sk-font--B" v-if="index > 0" @click="handleDelete(index)"></i>
    </div>
    <div style="color: red;">{{ message }}</div>
    <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="handleAdd">
      添加
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { COMMON_MNG, PRODUCT_MNG, OSTYPE_MNG } from '@/api/apiModules'
export default {
  name: 'SkyProductOsCompatRelate',
  inject: ['rootView'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    row: {}
  },
  data() {
    return {
      loading: false,
      message: null,
      osList: [],
      productList: [],
      compatibleList: [],
      variableArr: [
        {
          productVersion: null,
          os: null,
          compatibleStatus: null,
          limitDesc: null
        }
      ]
    }
  },
  created() {
    if (this.value) {
      this.variableArr = this.value
    }
  },
  mounted() {
    if (this.row?.projectId) {
      this.osList = this.row.osType
        .split(',')
        .filter((item, index, self) => self.indexOf(item) === index)
        .map(item => {
          return {
            id: item,
            label: item
          }
        })
      if (this.row.productVersion) {
        this.productList = this.row.productVersion
          .split(',')
          .filter((item, index, self) => self.indexOf(item) === index)
          .map(item => {
            return {
              id: item,
              label: item
            }
          })
      }
    } else {
      action(OSTYPE_MNG, 'findAllActive').then(response => {
        this.osList = response.data.content.itemArr.map(item => {
          return {
            id: item.osType,
            label: item.osType
          }
        })
      })
      action(PRODUCT_MNG, 'findAllActive').then(response => {
        this.productList = response.data.content.itemArr.map(item => {
          return {
            id: item.productVersion,
            label: item.productVersion
          }
        })
      })
    }

    action(COMMON_MNG, 'compatibleStatus').then(response => {
      this.compatibleList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.label
        }
      })
    })
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        if (this.variableArr.length) {
          for (const data of this.variableArr) {
            if (!this.isFill(data)) {
              hasError = true
              callback(new Error(this.$t('支持的产品版本与操作系统不能为空')))
              break
            }
          }
        }
        if (this.isDuplicate()) {
          hasError = true
          callback(new Error(this.$t('支持的兼容性组合不能重复')))
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.handleFill(value)
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.productVersion && item.os && item.compatibleStatus
    },
    handleAdd() {
      this.variableArr.push({
        productVersion: null,
        os: null,
        limitDesc: null
      })
    },
    handleFill(value) {
      this.variableArr = value
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    },
    isDuplicate() {
      if (this.variableArr.length) {
        const set = new Set()
        return this.variableArr.some(obj => {
          const combination = obj['productVersion'] + '-' + obj['os']
          if (set.has(combination)) {
            return true
          } else {
            set.add(combination)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(product-os-compat) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
